import { BaseService, Service } from "/@/cool";
@Service("dealerFrozen")
class dealerFrozen extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
	}
}
export default dealerFrozen;
